import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns, ServiceColumns } from "../product/Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { useBranch } from "../../../../context/BranchContext";
import { Col, Dropdown, FormLabel, Row } from "react-bootstrap";
import { useState } from "react";
import CatalogDetailsModal from "./CatalogDetailsModal";
import { warnAlert } from "../../../components/alert/defaultAlert";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import InputText from "../../../components/Forms/Element/InputText";
import CategorySelect from "../../../components/Custom/Main/Category/CategorySelect";
import StatusFilterSelect, { DEFAULT_STATUS, buildStatusFilter } from "../../../components/Common/Filter/StatusFilterSelect";
import { SearchOperation } from "../../../../utils/ApiUtils";
// Compartilha o estilo do aviso de serviço sem tempo com o formulário.
import "./CatalogForm.css";

const CatalogList = ({ type }) => {

    const { t } = useTranslation();
    const { selectedBranch } = useBranch();
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [nameFilter, setNameFilter] = useState('');
    const [categoryFilter, setCategoryFilter] = useState(null);
    // A grade já abre só com ativos, então o select nasce em Ativo: o campo mostra o recorte
    // que está valendo em vez de parecer vazio.
    const [statusFilter, setStatusFilter] = useState(DEFAULT_STATUS);
    const isService = type === "SERVICE";
    const menu = isService ? MenuConfig.main.service : MenuConfig.main.product;
    const title = isService ? t("services") : t("products");
    const typeFilter = {
        field: "type",
        value: type,
        operation: SearchOperation.EQUAL
    };
    const [filters, setFilters] = useState([typeFilter]);

    const handleViewImage = () => {
        if (selectedRows.length === 0) {
            warnAlert(t('validation.required.row'));
            return;
        }
        setSelectedProduct(selectedRows[0]);
        setShowImageModal(true);
    };

    const handleSearch = () => {
        const activeFilters = [typeFilter];

        if (nameFilter && nameFilter.trim()) {
            activeFilters.push({
                field: "name",
                value: nameFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }

        if (categoryFilter) {
            activeFilters.push({
                field: "category.id",
                value: categoryFilter.value,
                operation: SearchOperation.EQUAL
            });
        }

        activeFilters.push(buildStatusFilter(statusFilter));

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setNameFilter('');
        setCategoryFilter(null);
        setStatusFilter(DEFAULT_STATUS);
        setFilters([typeFilter]);
    };

    const customButtons = (
        <>
            <Dropdown.Item onClick={handleViewImage}>
                <i className="fas fa-info-circle me-2"></i> {t('view_details')}
            </Dropdown.Item>
        </>
    );

    return (
        <>
            <PageTitle activeMenu={title} motherMenu={t("main")} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                <Row className="g-2 align-items-end">
                    <Col lg={4} md={6}>
                        <FormLabel>{t('name')}</FormLabel>
                        <InputText
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                            placeholder={t('product_name_placeholder')}
                        />
                    </Col>
                    <Col lg={4} md={6}>
                        <FormLabel>{t('category')}</FormLabel>
                        <CategorySelect
                            value={categoryFilter}
                            onChange={(value) => setCategoryFilter(value)}
                            isClearable={true}
                        />
                    </Col>
                    <Col lg={4} md={6}>
                        <StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={title}
                motherMenu={t("main")}
                path={Api.main.product}
                route={menu.route}
                columns={isService ? ServiceColumns : Columns}
                selectedBranch={selectedBranch}
                multiBranchSupport={true}
                customButtons={customButtons}
                setSelectedRows={setSelectedRows}
                filters={filters}
                hideInactiveToggle
            />
            
            <CatalogDetailsModal
                show={showImageModal}
                onHide={() => setShowImageModal(false)}
                itemId={selectedProduct?.id}
                type={type}
            />
        </>
    );
}

export default CatalogList;
